import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes } from '../models/routes.model';
import { AppContextService } from '../services/app-context.service';
import { EcommerceAuthService } from '../services/ecommerce/ecommerce-auth.service';
import { KeycloakInitStateService } from '../services/keycloak-init-state.service';

/**
 * Protegge l'area acquisti: passa con Keycloak o con la sessione legacy.
 * Senza autenticazione avvia il login Keycloak conservando la rotta richiesta,
 * come `authGuard`; il ritorno al carrello vale solo se il redirect non parte.
 *
 * Se il ritorno da Keycloak è appena fallito, il login non viene riavviato:
 * con il cookie di sessione già sul realm si tornerebbe qui in loop. Si va al
 * carrello, che è pubblico, e l'avviso nel layout spiega cosa è successo.
 */
export const ecommerceSessionGuard: CanActivateFn = async (_route, state) => {
  const ecommerceAuthService = inject(EcommerceAuthService);
  // `inject` va risolto prima di qualsiasi await (NG0203).
  const router = inject(Router);
  const appContextService = inject(AppContextService);
  const initState = inject(KeycloakInitStateService);

  if (ecommerceAuthService.isAuthenticated()) {
    return true;
  }

  const cartUrl = router.parseUrl(appContextService.buildAppScopedUrl(AppRoutes.CARRELLO));

  if (initState.loginFailed()) {
    initState.showNotice();
    return cartUrl;
  }

  await ecommerceAuthService.loginWithKeycloak(state.url);
  return cartUrl;
};
